import { Text } from "@mantine/core";
import { useMemo } from "react";
import useSWR from "swr";
import { TenantFeePolicyAssignmentApi } from "../../apis";
import { ShortId } from "./ShortId";

// Tenant-scoped end-customer name resolution: the /bil/my/fee-policy-customers
// roster maps businessId -> name for the CURRENT tenant only. Use this only on
// screens confirmed to be tenant-scoped (e.g. the /my collected-fees and
// assignments lists). On cross-tenant admin lists use <ShortId> instead — there
// is no business-name-by-ids endpoint. SWR dedupes by key (one shared fetch).
export function useMyCustomerNameMap(): Map<string, string> {
  const { data } = useSWR(
    "swr.my.customer-roster.namemap",
    () => TenantFeePolicyAssignmentApi.listCustomers({ page: 1, limit: 1000 }),
    { revalidateOnFocus: false }
  );
  return useMemo(() => {
    const m = new Map<string, string>();
    (data?.rows ?? []).forEach((c) => { if (c.name) m.set(c.businessId, c.name); });
    return m;
  }, [data]);
}

export function MyCustomerName({ id }: { id: string }) {
  const map = useMyCustomerNameMap();
  const name = id ? map.get(id) : undefined;
  if (!name) return <ShortId id={id} />;
  return <Text size="sm">{name}</Text>;
}
